var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"fade-transform","mode":"out-in"}})
}
var staticRenderFns = []

export { render, staticRenderFns }